import { firebaseAnalyticsContext } from "firebase/analytics/firebase-analytics-service";
import { useContext } from "react";

export function useFirebaseAnalytics() {
  const firebaseAnalytics = useContext(firebaseAnalyticsContext);

  if (firebaseAnalytics === null) {
    throw new Error("ERROR: firebase Analytics not yet initialized");
  }

  return firebaseAnalytics;
}
